import React, { useState, useEffect } from 'react';
import { BarChart3, Target, Radio, Megaphone, TrendingUp } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const StatColumn = ({ icon: Icon, title, rows, max }) => (
  <div className="attr-stats-col">
    <div className="attr-stats-col-header">
      <Icon size={14} />
      <span>{title}</span>
    </div>
    {rows.length === 0 ? (
      <div className="attr-stats-empty">No data yet</div>
    ) : (
      <ul className="attr-stats-list">
        {rows.map((r) => {
          const pct = max > 0 ? Math.round((r.count / max) * 100) : 0;
          const isDirect = r.key === '(direct)';
          return (
            <li key={r.key} className={`attr-stats-row ${isDirect ? 'is-direct' : ''}`}>
              <div className="attr-stats-key" title={r.key}>{r.key}</div>
              <div className="attr-stats-bar-wrap">
                <div className="attr-stats-bar" style={{ width: `${pct}%` }} />
              </div>
              <div className="attr-stats-count">{r.count}</div>
            </li>
          );
        })}
      </ul>
    )}
  </div>
);

const AttributionStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('adminToken');
        const res = await axios.get(`${API}/admin/attribution-stats`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setStats(res.data);
      } catch (e) {
        setStats(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div className="attr-stats-loading">Loading attribution stats...</div>;
  if (!stats || stats.total === 0) return null;

  const maxOf = (rows) => rows.reduce((m, r) => Math.max(m, r.count), 0);

  return (
    <div className="attr-stats-widget" data-testid="attribution-stats-widget">
      <div className="attr-stats-header">
        <div className="attr-stats-title">
          <BarChart3 size={16} />
          <span>Attribution Overview</span>
        </div>
        <div className="attr-stats-summary">
          <span className="attr-stats-summary-item">
            <strong>{stats.total}</strong> total leads
          </span>
          <span className="attr-stats-summary-item">
            <TrendingUp size={12} />
            <strong>{stats.attribution_rate}%</strong> attributed
            <span className="attr-stats-summary-detail">({stats.attributed}/{stats.total})</span>
          </span>
        </div>
      </div>

      <div className="attr-stats-grid">
        <StatColumn
          icon={Radio}
          title="Top Sources"
          rows={stats.by_source}
          max={maxOf(stats.by_source)}
        />
        <StatColumn
          icon={Target}
          title="Top Mediums"
          rows={stats.by_medium}
          max={maxOf(stats.by_medium)}
        />
        <StatColumn
          icon={Megaphone}
          title="Top Campaigns"
          rows={stats.by_campaign}
          max={maxOf(stats.by_campaign)}
        />
      </div>
    </div>
  );
};

export default AttributionStats;
